/**
 * Validates a phone number to ensure it starts with either "25078", "25072", or "25073".
 * @param {string} phoneNumber - The phone number to validate.
 * @returns {boolean} True if the phone number is valid, false otherwise.
 */
export function validatePhoneNumber(phoneNumber) {
  const regex = /^2507[823]\d{6}$/;
  return regex.test(phoneNumber);
}
